import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // private readonly basePath = 'https://dev-api.facheck.biz/' // dev

  private readonly basePath2 = 'https://staging-api.facheck.biz/'  // staging
  
  private readonly basePath = 'https://api.facheck.biz/'  // production

  // Contact Us form
  private readonly contactusform = 'ticketraiser/webticket'
  private readonly captcha = 'ticketraiser/webcaptcha';

  // sign up
  private readonly getotp = 'user/selfCreation-websiteEmailVerify';
  private readonly signup = 'user/selfCreation-website';

  constructor(private http:HttpClient) { }

  contactUsForm(data:any):Promise<any>{
   return lastValueFrom(this.http.post(`${this.basePath}${this.contactusform}`,data)) 
  }

  signUp(data:any):Promise<any>{
   return lastValueFrom(this.http.post(`${this.basePath2}${this.signup}`,data)) 
  }

  getOTP(data:any):Promise<any>{
   return lastValueFrom(this.http.post(`${this.basePath2}${this.getotp}`,data)) 
  }

  getCaptcha(data:any):Promise<any>{
    return lastValueFrom(this.http.post(`${this.basePath}${this.captcha}`,data)) 
   }

   //DecryptData
  decryptData(paymentdetailstwo: string) {
    const key = CryptoJS.enc.Utf8.parse('Its007Ab10hI23Sh11e09K17102001OG');
    const decryptedBytes = CryptoJS.AES.decrypt(paymentdetailstwo, key, {
      mode: CryptoJS.mode.ECB,
      paddin: CryptoJS.pad.Pkcs7
    });
    return decryptedBytes.toString(CryptoJS.enc.Utf8);
  }

  //EncryptData
  encrypt(value: string) {
    const key = CryptoJS.enc.Utf8.parse('Its007Ab10hI23Sh11e09K17102001OG');
    const encrypted = CryptoJS.AES.encrypt(value, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString();
  }
}
